import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-svg';

var CardHeader =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CardHeader, _PureComponent);

  function CardHeader() {
    _classCallCheck(this, CardHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(CardHeader).apply(this, arguments));
  }

  _createClass(CardHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          svgName = _this$props.svgName,
          svgUrl = _this$props.svgUrl;
      var url;

      if (svgUrl) {
        url = svgUrl;
      } else if (svgName) {
        url = "https://static.ux.cimpress.io/assets/icons/".concat(svgName, ".svg");
      }

      return React.createElement("div", {
        style: {
          padding: '8.5px 1px',
          maxWidth: '220px',
          margin: '0 auto',
          textAlign: 'center',
          position: 'relative'
        }
      }, React.createElement(SVG, {
        path: "https://static.ux.cimpress.io/assets/icons/card_icon_bg.svg"
      }), React.createElement(SVG, {
        path: url,
        style: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '24px',
          height: '24px'
        }
      }));
    }
  }]);

  return CardHeader;
}(PureComponent);

export { CardHeader as default };
CardHeader.propTypes = {
  svgUrl: PropTypes.string,
  svgName: PropTypes.string
};